import { NavLink } from 'react-router-dom';
import { Home, Compass, Music, TrendingUp, BarChart3, Heart, ListMusic } from 'lucide-react';
import { cn } from '../../lib/cn.js';

const navItems = [
  { to: '/', icon: Home, label: 'Inicio' },
  { to: '/search', icon: Compass, label: 'Explorar' },
  { to: '/genres', icon: Music, label: 'Géneros' },
  { to: '/charts/weekly', icon: BarChart3, label: 'Charts' },
  { to: '/trending', icon: TrendingUp, label: 'Trending' },
];

const userItems = [
  { to: '/favorites', icon: Heart, label: 'Favoritos' },
  { to: '/playlists', icon: ListMusic, label: 'Playlists' },
];

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export function Sidebar({ isOpen, onClose }: SidebarProps) {
  return (
    <>
      {/* Mobile overlay */}
      {isOpen && <div className="fixed inset-0 z-40 bg-black/50 lg:hidden" onClick={onClose} />}

      {/* Sidebar */}
      <aside
        className={cn(
          'fixed top-16 left-0 bottom-0 z-40 w-[220px] bg-surface border-r border-border flex flex-col transition-transform duration-200',
          'lg:translate-x-0',
          isOpen ? 'translate-x-0' : '-translate-x-full',
        )}
      >
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
          <p className="px-3 py-2 text-xs font-semibold text-text-muted uppercase tracking-wider">
            Menú
          </p>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={onClose}
              end={item.to === '/'}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary/10 text-primary'
                    : 'text-text-secondary hover:bg-surface-hover hover:text-text-primary',
                )
              }
            >
              <item.icon size={18} />
              {item.label}
            </NavLink>
          ))}

          <div className="my-3 border-t border-border" />

          <p className="px-3 py-2 text-xs font-semibold text-text-muted uppercase tracking-wider">
            Mi Música
          </p>
          {userItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={onClose}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary/10 text-primary'
                    : 'text-text-secondary hover:bg-surface-hover hover:text-text-primary',
                )
              }
            >
              <item.icon size={18} />
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
}
